module.exports = __webpack_public_path__ + "media/images/iconbox/icon4-bf5e25f38b2f9ddd4dc6dc652cf76512.png";